import { render, staticRenderFns } from "./sms_reply_record.vue?vue&type=template&id=68ef81a3&scoped=true"
import script from "./sms_reply_record.vue?vue&type=script&lang=js"
export * from "./sms_reply_record.vue?vue&type=script&lang=js"
import style0 from "./sms_reply_record.vue?vue&type=style&index=0&id=68ef81a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ef81a3",
  null
  
)

export default component.exports